import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import type { Brand } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {};
type Response = {
  data: Brand[];
};

export const useBrands = createQuery<Response, Variables, AxiosError>({
  queryKey: ['brands'],
  fetcher: () => {
    return client.get(`v2/internal/partners/brands`).then((response) => {
      return response.data.data;
    });
  },
});
